import React from 'react';
// import { compose, withProps, lifecycle } from "recompose";
// import {
//   withScriptjs,
//   withGoogleMap,
//   GoogleMap,
//   DirectionsRenderer}
// from "react-google-maps";

const { compose, withProps, lifecycle } = require("recompose");
const {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  DirectionsRenderer,
} = require("react-google-maps");


const MapLoader = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyCZ-lrgcyu8rNUArDpZuWSEPVoLBBNt2zE&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap,

  lifecycle({
    componentDidMount() {

      const DirectionsService = new window.google.maps.DirectionsService();
      const{origin_lat, origin_lng, destination_lat, destination_lng} = this.props;
      console.log("origin_lat", origin_lat);
      console.log("origin_lng", origin_lng);
      console.log("destination_lat", destination_lat);
      console.log("destination_lng", destination_lng);

      DirectionsService.route({
        origin: {lat: origin_lat, lng: origin_lng },//new google.maps.LatLng(41.8507300, -87.6512600),
        destination: {lat: destination_lat, lng: destination_lng },//new google.maps.LatLng(41.8525800, -87.6514100),
        travelMode: window.google.maps.TravelMode.DRIVING,
      }, (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          this.setState({
            directions: result,
          });
        } else {
          console.error(`error fetching directions ${result}`);
        }
      });
    }
  })
)(props =>
  <GoogleMap
    defaultZoom={7}
    defaultCenter={{lat: 0.347596, lng: 32.582520}}//{new google.maps.LatLng(41.8507300, -87.6512600)}
  >
    {props.directions && <DirectionsRenderer directions={props.directions} />}
  </GoogleMap>
);

export default MapLoader;